import Image from "next/image";
import BostonBeerLogo from "@/../public/images/bbc-logo.svg";

export function BbcLogo({ className }: {
  className?: string,
}) {
  return <Image src={BostonBeerLogo} alt={"Boston Beer Company Logo"} className={className} loading="eager" />;
}
